import Vue from 'vue'
import GenericConfirm from '@/components/modals/GenericConfirm.vue'
import Generic from '@/components/modals/Generic.vue'

function openGenericConfirmModal(self, title, content, buttonText) {
  var data = {
    title: title,
    content: content,
    buttonText: buttonText,
  }
  return createModal(GenericConfirm, self, data)
}

function openGenericModal(self, title, content, showButton) {
  console.log('s')
  var data = {
    showUpgradeButton: showButton,
    title: title,
    content: content,
  }
  return createModal(Generic, self, data)
}

function createModal(component, self, data) {
  console.log('s')
  var promise = new Promise((resolve, reject) => {
    var instance
    var _promise = new Promise((_resolve, _reject) => {
      var ComponentClass = Vue.extend(component)
      instance = new ComponentClass({
        parent: self,
        language: self.$language,
        propsData: data,
      })
      instance.$mount() // pass nothing

      instance.$on('close', () => {
        _reject()
      })
      instance.$on('resolve', (data) => {
        _resolve(data)
      })

      document.getElementById('app').appendChild(instance.$el)
    })
      .then((success) => {
        resolve(success)
      })
      .catch((error) => {
        reject(error)
      })
      .finally(() => {
        document.documentElement.classList.remove('modal-open')
        instance.$destroy()
        instance.$el.parentNode.removeChild(instance.$el)
      })
  })
  return promise
}



export {
  createModal,
  openGenericConfirmModal,
  openGenericModal,
}
